module.exports = __webpack_public_path__ + "static/media/HeroSection.232a6a07.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/HeroSection.png
// module id = 1871
// module chunks = 0